<template>
    <div class="backend-container">
        <BackendHeader />
        <h1>Post Deals to Facebook</h1>
        <div><a href="https://www.facebook.com/mymommydeals" target="_blank">Link to Facebook Page</a> <a href="https://www.facebook.com/groups/mymommydeals" target="_blank">Link to Facebook Group</a></div>
        <div>
            <table v-if="deals">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Link</th>
                        <th>Title</th>
                        <th>Post</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(deal, index) in deals" :key="index">
                        <td>
                            {{deal.dealId}}
                        </td>
                        <td>
                            <div class="img-container">
                                <div>
                                    <button @mouseover="deal.showImg = true" @mouseout="deal.showImg = false">IMG</button>
                                </div>
                                <div class="floating" v-show="deal.showImg">
                                    <img :src="deal.imgUrl" class="deal-img" />
                                </div>
                            </div>
                        </td>
                        <td>
                            <a :href="deal.dealLink" target="_blank">LINK TO DEAL</a>
                        </td>
                        <td>
                            <div class="deal-title">{{deal.title}}</div>
                        </td>
                        <td>
                            <textarea v-model="deal.post" class="post-textarea"></textarea>
                        </td>
                        <td>
                            <div v-show="deal.isBusyPage">
                                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
                            </div>
                            <div v-show="!deal.isBusyPage">
                                <button v-show="!deal.isPostedPage" @click="postToFacebookPage(deal)">Post to Facebook Page</button>
                                <span v-show="deal.isPostedPage"><a href="https://www.facebook.com/mymommydeals" target="_blank">DEAL POSTED on PAGE</a></span>
                            </div>
                        </td>
                        <td>
                            <div v-show="deal.isBusyGroup">
                                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
                            </div>
                            <div v-show="!deal.isBusyGroup">
                                <button v-show="!deal.isPostedGroup" @click="postToFacebookGroup(deal)">Post to Facebook Group</button>
                                <span v-show="deal.isPostedGroup"><a href="https://www.facebook.com/groups/mymommydeals" target="_blank">DEAL POSTED on Group</a></span>
                            </div>
                        </td>
                        <td>
                            <div v-show="deal.isBusyTwitter">
                                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
                            </div>
                            <div v-show="!deal.isBusyTwitter">
                                <button v-show="!deal.isPostedTwitter" @click="postToTwitter(deal)">Post to Twitter</button>
                                <span v-show="deal.isPostedTwitter"><a href="https://twitter.com/MyMommyDeals" target="_blank">DEAL POSTED on Twitter</a></span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import api from '@/api'
import settings from '@/settings'
import BackendHeader from '@/components/BackendHeader.vue'
import { DealDetails } from '@/classes/DealDetails'

interface ExtendedDeal extends DealDetails {
    post: string;
    showImg: boolean;
    isBusyPage: boolean;
    isBusyGroup: boolean;
    isBusyTwitter: boolean;
    isPostedPage: boolean;
    isPostedGroup: boolean;
    isPostedTwitter: boolean;
    dealLink: string;
}

export default defineComponent({
    name: "Backend",
    components: {
        BackendHeader
    },
    setup() {
        const deals = ref<ExtendedDeal[] | null>(null);

        const postToFacebookPage = async (deal: ExtendedDeal) => {
            deal.isBusyPage = true;
            const post = {
                message: deal.post,
                imgUrl: deal.imgUrl,
                link: deal.dealLink
            };
            try {
                const response = await api.postToFacebookPage(post);
                console.log('response', response);
                deal.isBusyPage = false;
                deal.isPostedPage = true;

                setTimeout(() => {
                    deal.isPostedPage = false;
                }, 3000);
            } catch (error) {
                deal.isBusyPage = false;
                console.error('Error posting to Facebook Page:', error);
            }
        };

        const postToFacebookGroup = async (deal: ExtendedDeal) => {
            deal.isBusyGroup = true;
            const post = {
                message: deal.post,
                imgUrl: deal.imgUrl,
                link: deal.dealLink
            };
            try {
                const response = await api.postToFacebookGroup(post);
                console.log('response', response);
                deal.isBusyGroup = false;
                deal.isPostedGroup = true;
                setTimeout(() => {
                    deal.isPostedGroup = false;
                }, 3000);
            } catch (error) {
                deal.isBusyGroup = false;
                console.error('Error posting to Facebook Group:', error);
            }
        };

        const postToTwitter = async (deal: ExtendedDeal) => {
            deal.isBusyTwitter = true;
            const post = {
                message: deal.post,
                imgUrl: deal.imgUrl
            };
            try {
                const response = await api.postToTwitter(post);
                console.log('response', response);
                deal.isBusyTwitter = false;
                deal.isPostedTwitter = true;
                setTimeout(() => {
                    deal.isPostedTwitter = false;
                }, 3000);
            } catch (error) {
                deal.isBusyTwitter = false;
                console.error('Error posting to Twitter:', error);
            }
        };

        const getDeals = async () => {
            try {
                const response = await api.getLatestDeals(50, 1, null);
                const dealsData = response.data.map((d: DealDetails) => {
                    const post = d.dealPrice === -1 ? 'Great Deal!' : `Great Deal! Only $${d.dealPrice}!`;
                    return {
                        ...d,
                        post,
                        showImg: false,
                        isBusyPage: false,
                        isBusyGroup: false,
                        isBusyTwitter: false,
                        isPostedPage: false,
                        isPostedGroup: false,
                        isPostedTwitter: false,
                        dealLink: `https://${settings.siteUrl}/deal/${d.dealId}`
                    } as ExtendedDeal;
                });

                deals.value = dealsData;
            } catch (error) {
                console.error('Error fetching deals:', error);
            }
        };

        onMounted(() => {
            getDeals();
        });

        return {
            deals,
            postToFacebookPage,
            postToFacebookGroup,
            postToTwitter
        };
    }
});
</script>
